// NOTE: Any changes to this enum should also update the regex in the BrowsePageController.
export enum BROWSE_TABS {
    CATALOG = 'catalog', // TODO: Clean this once server supports the US Catalog version
    CATALOGUE = 'catalogue',
    PLAYLISTS = 'playlists',
    INSTRUMENTS = 'instruments',
}

export interface SortParams {
    sortBy: string;
    sortOrder: string;
}
